var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './pagination.module.scss';
import { Pager } from 'src/ui/components/Pager/Pager';
import { ResultsPerPage } from './components/ResultsPerPage';
export var Pagination = function (props) {
    var i18n = props.i18n, total = props.total, nbByPage = props.nbByPage, isResultsPerPageDisabled = props.isResultsPerPageDisabled, nbOfPages = props.nbOfPages, currentPage = props.currentPage, onPageChange = props.onPageChange, onResultsPerPageChange = props.onResultsPerPageChange;
    var startPositionOfResult = (currentPage - 1) * nbByPage;
    var endPositionOfResult = startPositionOfResult + nbByPage;
    var endPositionLimited = endPositionOfResult <= total ? endPositionOfResult : total;
    var currentPosition = "".concat(startPositionOfResult + 1, " - ").concat(endPositionLimited, " sur ").concat(total);
    var handlePageChange = function (newPage) {
        onPageChange(newPage);
    };
    var handleResultsPerPageChange = function (newValue) {
        onResultsPerPageChange(newValue);
    };
    return (_jsxs("div", __assign({ className: styles.paginationWrapper }, { children: [_jsxs("div", __assign({ className: styles.searchResultsInfos }, { children: [_jsx("p", __assign({ className: styles.currentPosition }, { children: currentPosition })), _jsx(ResultsPerPage, { i18n: i18n, totalResults: total, resultsPerPage: nbByPage, disabled: isResultsPerPageDisabled, onChange: handleResultsPerPageChange })] })), _jsx(Pager, { nbOfPages: nbOfPages, currentPage: currentPage, onChange: handlePageChange })] })));
};
